import { Reveal, Overline } from "@/components/motion";
import { MANIFESTO, IMAGES } from "@/data/site";

const Manifesto = () => {
  return (
    <section id="process" className="py-24 md:py-36 bg-foreground text-background" data-testid="process-section">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal><Overline className="text-background/50">How It Works</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-serif text-4xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[0.95]">
                Three steps to spotless.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 overflow-hidden aspect-[4/3] hidden lg:block">
                <img src={IMAGES.steam_press} alt="Steam press finishing" className="w-full h-full object-cover grayscale" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.no} delay={i * 0.1}>
                <div className="grid grid-cols-12 gap-4 py-8 md:py-10 border-b border-background/20">
                  <span className="col-span-12 md:col-span-2 font-serif text-4xl md:text-5xl font-light text-background">{m.no}</span>
                  <div className="col-span-12 md:col-span-10">
                    <h3 className="font-sans text-xl md:text-2xl font-medium tracking-tight">{m.title}</h3>
                    <p className="mt-3 text-base font-light text-background/60 leading-relaxed max-w-xl">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
